import { render } from "./ProjectItem.vue?vue&type=template&id=3a3ae3ba&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=3a3ae3ba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3ae3ba"]])

export default __exports__